import React from 'react';
import PropagateLoader from 'react-spinners/PropagateLoader';
import { Box } from '@mui/material';
import { colors } from 'theme/colors';

interface ILoader {
  isLoading: boolean;
  color?: string;
  my?: number;
}
const Loader = ({ isLoading, color, my = 4 }: ILoader) => (
  <Box sx={{ display: 'flex', justifyContent: 'center', my }}>
    <PropagateLoader loading={isLoading} color={color ?? colors.primary500} />
  </Box>
);

export { Loader };
